import { CloningCampaignsContextProvider } from './context';
import { CloneJourneyFormProvider } from './context/CloneJourneyFormProvider';
import { CloneJourneyModal as CloneJourney, Props } from './CloneJourneyModal';

export * from './utils';

export const CloneJourneyModal = (props: Props) => {
  return (
    <CloneJourneyFormProvider>
      <CloningCampaignsContextProvider>
        <CloneJourney {...props} />
      </CloningCampaignsContextProvider>
    </CloneJourneyFormProvider>
  );
};
